<template>
    <FilterBody
        :label="t('projectclient.projectlist.table.status.header')"
        :items="statusAggregations"
        :selected-items="screenSizeSearchParams.status"
        @reset="projectListFiltersStore.handleResetCategory('status')"
        @check:item="handleCheckBoxChange"
    >
        <template #item="{item}">
            {{ `${t(`projectclient.projectlist.table.status.value.${item.label}`)} (${item.count})` }}
        </template>
    </FilterBody>
</template>

<script lang="ts" setup>
    import {computed} from 'vue';
    import type {TypedAggregationResource} from '@common/composables';
    import {useScreenSizeStore} from '@common/stores';
    import {useProjectsListStore, useProjectsListFiltersStore} from '@features/projects-list/stores';
    import {storeToRefs} from 'pinia';
    import {useTranslation} from '#imports';
    import type {ProjectStatus} from '@api';
    import FilterBody from '../wrappers/FilterBody.vue';

    const {t} = useTranslation();

    const screenSizeStore = useScreenSizeStore();
    const {isSmallScreen} = storeToRefs(screenSizeStore);

    const projectListStore = useProjectsListStore();
    const {searchParams} = storeToRefs(projectListStore);

    const projectListFiltersStore = useProjectsListFiltersStore();
    const {statusAggregations, temporarySearchParams} = storeToRefs(projectListFiltersStore);

    const screenSizeSearchParams = computed(() => {
        if (isSmallScreen.value) {
            return temporarySearchParams.value;
        } else {
            return searchParams.value;
        }
    });

    function handleCheckBoxChange(item: TypedAggregationResource<ProjectStatus>) {
        projectListFiltersStore.handleUpdateCategory('status', item.value);
    }
</script>
